<template>
  <div>
    <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <b-skeleton width="85%"></b-skeleton>
        <b-skeleton width="55%"></b-skeleton>
        <b-skeleton width="70%"></b-skeleton>
      </template>
      <RangeSlider
        label="servers.numberOfCores"
        id="cpu"
        v-model="form.cpu"
        :defaultValue="vmData.total_cpu"
        :min="
          vmData.datacenterNode && vmData.datacenterNode.data
            ? vmData.datacenterNode.data.min_cpu_limit
            : 0
        "
        :max="
          vmData.datacenterNode && vmData.datacenterNode.data
            ? vmData.datacenterNode.data.max_cpu_limit
            : 0
        "
        unit="Core"
        step="1"
        :state="validateState('cpu')"
      />

      <RangeSlider
        label="servers.memorySize"
        id="ram"
        v-model="form.ram"
        :defaultValue="$customFunctions.convertMBtoGB(vmData.total_ram)"
        :min="
          vmData.datacenterNode && vmData.datacenterNode.data
            ? $customFunctions.convertMBtoGBWithHalfPoint(
                vmData.datacenterNode.data.min_ram_limit
              )
            : 0
        "
        :max="
          vmData.datacenterNode && vmData.datacenterNode.data
            ? $customFunctions.convertMBtoGBWithHalfPoint(
                vmData.datacenterNode.data.max_ram_limit
              )
            : 0
        "
        unit="GB"
        step="0.5"
        :state="validateState('ram')"
      />

      <b-button
        type="submit"
        :variant="vmData.status != 'halted' ? 'light' : 'primary'"
        :disabled="
          form.cpu == vmData.total_cpu &&
          form.ram == $customFunctions.convertMBtoGB(vmData.total_ram)
        "
        @click="confirm"
        class="px-10"
        >{{ $t('global.update') }}</b-button
      >
    </b-skeleton-wrapper>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import EventBus from '@/event-bus'

export default {
  name: 'CpuRamCluster',
  mixins: [validationMixin],
  props: {
    vmData: String | Array,
  },
  data() {
    return {
      loading: false,
      form: {
        cpu: 0,
        ram: 0,
      },
      estimate: '',
    }
  },
  validations: {
    form: {
      cpu: {
        required,
      },
      ram: {
        required,
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    confirm() {
      if (this.vmData.status != 'halted') {
        EventBus.$emit('notificationError', {
          title: '',
          description: this.$t('servers.vmMustBeHalted'),
        })
      } else {
        this.$v.form.$touch()
        if (this.$v.form.$anyError) {
          return
        }

        if (this.vmData && this.vmData.total_cpu == this.form.cpu) {
          //do nothing!
        } else {
          this.loading = true
          let params = {
            size: this.form.cpu,
          }
          ApiService.put(
            `iaas/virtual-machines/${this.vmData.id}/change-cpu-size`,
            params
          )
            .then(({ data }) => {
              this.$generateToast(
                this,
                'success',
                this.$t('servers.cpuUpdatedSuccessfully')
              )
              this.vmData.total_cpu = this.form.cpu
              this.loading = false
            })
            .catch((err) => {
              this.loading = false
            })
        }

        if (
          this.vmData &&
          this.$customFunctions.convertMBtoGB(this.vmData.total_ram) ==
            this.form.ram
        ) {
          //do nothing!
        } else {
          this.loading = true
          let params = {
            size: this.$customFunctions.convertGBtoMB(this.form.ram),
          }
          ApiService.put(
            `iaas/virtual-machines/${this.vmData.id}/change-memory-size`,
            params
          )
            .then(({ data }) => {
              this.$generateToast(
                this,
                'success',
                this.$t('servers.ramUpdatedSuccessfully')
              )
              this.vmData.total_ram = this.$customFunctions.convertGBtoMB(
                this.form.ram
              )
              this.loading = false
            })
            .catch((err) => {
              this.loading = false
            })
        }
      }
    },
  },
}
</script>
